/**
 * Life4Earth V2 — Digest Acknowledgments API Adapter
 *
 * Tracks when a user acknowledges an "Informed" (I) item
 * in the Role Digest.
 *
 * Endpoint: /api/projects/{guid}/digest-acknowledgments
 *
 * Epic: DEV-712, Task: DEV-719
 */

import { apiFetch } from "./client";

// ── Types ─────────────────────────────────────────────────────

export interface DigestAcknowledgmentResponse {
  userGuid: string;
  ganttTaskId: string;
  roleSlotGuid: string;
  acknowledgedAt: string;
  /** Optional governance rationale. DEV-736. */
  note: string | null;
}

export interface AcknowledgeRequest {
  ganttTaskId: string;
  roleSlotGuid: string;
  /**
   * Optional rationale. First ack: persisted verbatim. Subsequent ack
   * with a new non-empty note: updates existing record's note
   * (note-append flow). Null or empty: no change to existing note. DEV-736.
   */
  note?: string | null;
}

// ── API Functions ─────────────────────────────────────────────

/**
 * Fetch all acknowledgments for a user on a project.
 */
export async function fetchDigestAcknowledgments(
  projectGuid: string,
  userGuid: string
): Promise<DigestAcknowledgmentResponse[]> {
  return apiFetch<DigestAcknowledgmentResponse[]>(
    `/api/projects/${projectGuid}/digest-acknowledgments?userGuid=${encodeURIComponent(userGuid)}`
  );
}

/**
 * Acknowledge an "Informed" item (upsert — safe to call twice).
 */
export async function acknowledgeDigestItem(
  projectGuid: string,
  req: AcknowledgeRequest
): Promise<DigestAcknowledgmentResponse> {
  return apiFetch<DigestAcknowledgmentResponse>(
    `/api/projects/${projectGuid}/digest-acknowledgments`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    }
  );
}
